import { template } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
export interface Signature {
    Args: {
        class?: string;
    };
    Element: SVGElement;
}
const WrEllipsisIconComponent: TemplateOnlyComponent<Signature> = template(`
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M4 8C4 9.1 3.1 10 2 10C0.9 10 0 9.1 0 8C0 6.9 0.9 6 2 6C3.1 6 4 6.9 4 8ZM8 6C6.9 6 6 6.9 6 8C6 9.1 6.9 10 8 10C9.1 10 10 9.1 10 8C10 6.9 9.1 6 8 6ZM14 6C12.9 6 12 6.9 12 8C12 9.1 12.9 10 14 10C15.1 10 16 9.1 16 8C16 6.9 15.1 6 14 6Z'
      fill='currentColor'
    />
  </svg>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default WrEllipsisIconComponent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3NlbWVpYS9wYWNrYWdlcy9lbWJlci1hZGRvbnMvdjIvZW1iZXItd2lzZXIvc3JjL2NvbXBvbmVudHMvd3IvaWNvbnMvZWxsaXBzaXMuZ3RzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgVGVtcGxhdGVPbmx5Q29tcG9uZW50IH0gZnJvbSAnQGVtYmVyL2NvbXBvbmVudC90ZW1wbGF0ZS1vbmx5JztcblxuZXhwb3J0IGludGVyZmFjZSBTaWduYXR1cmUge1xuICBBcmdzOiB7XG4gICAgY2xhc3M_OiBzdHJpbmc7XG4gIH07XG4gIEVsZW1lbnQ6IFNWR0VsZW1lbnQ7XG59XG5cbmNvbnN0IFdyRWxsaXBzaXNJY29uQ29tcG9uZW50OiBUZW1wbGF0ZU9ubHlDb21wb25lbnQ8U2lnbmF0dXJlPiA9IDx0ZW1wbGF0ZT5cbiAgPHN2Z1xuICAgIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZydcbiAgICB3aWR0aD0nMTYnXG4gICAgaGVpZ2h0PScxNidcbiAgICB2aWV3Qm94PScwIDAgMTYgMTYnXG4gICAgZmlsbD0nbm9uZSdcbiAgICBjbGFzcz17e0BjbGFzc319XG4gICAgLi4uYXR0cmlidXRlc1xuICA-XG4gICAgPHBhdGhcbiAgICAgIGQ9J000IDhDNCA5LjEgMy4xIDEwIDIgMTBDMC45IDEwIDAgOS4xIDAgOEMwIDYuOSAwLjkgNiAyIDZDMy4xIDYgNCA2LjkgNCA4Wk04IDZDNi45IDYgNiA2LjkgNiA4QzYgOS4xIDYuOSAxMCA4IDEwQzkuMSAxMCAxMCA5LjEgMTAgOEMxMCA2LjkgOS4xIDYgOCA2Wk0xNCA2QzEyLjkgNiAxMiA2LjkgMTIgOEMxMiA5LjEgMTIuOSAxMCAxNCAxMEMxNS4xIDEwIDE2IDkuMSAxNiA4QzE2IDYuOSAxNS4xIDYgMTQgNlonXG4gICAgICBmaWxsPSdjdXJyZW50Q29sb3InXG4gICAgLz5cbiAgPC9zdmc-XG48L3RlbXBsYXRlPjtcblxuZXhwb3J0IGRlZmF1bHQgV3JFbGxpcHNpc0ljb25Db21wb25lbnQ7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLGNBQWMscUJBQXFCLFFBQVEsaUNBQWlDO0FBRTVFLGlCQUFpQjtJQUNmO1FBQ0UsUUFBUSxNQUFNOztJQUVoQixTQUFTOztBQUdYLE1BQU0seUJBQXlCLHNCQUFzQixhQUFhLFNBQVUsQ0FBQTs7Ozs7Ozs7Ozs7Ozs7O0FBZTVFLENBQUEsRUFBQTtJQUFBO1FBQUEsT0FBQSxLQUFBLFNBQUEsQ0FBQSxFQUFXO0lBQUQ7QUFBQTtBQUVWLGVBQWUsd0JBQXdCIn0